export const subcategories = (state) => state.subcategories

export const getSubcategoryById = (state) => (id) => {
  return state.subcategories.find(subcategory => subcategory.id === id)
}